/*
  Sunne v2 – håll varukorgsikonen och varukorgslådan i takt när kunden
  backar i webbläsaren.

  PROBLEMET. Mobiltest 15 september 2026: kunden lade liftkort i varukorgen,
  gick till /cart och backade till prissidan. Sidan visades ur webbläsarens
  minne som den såg ut innan köpet – ingen siffra på väskan, och lådan sa
  "Din varukorg är tom" trots att varukorgen innehöll fem kort.

  Temat försöker redan rätta det här (on:bfcache:load-restore i
  cart-drawer.js), men bara när webbläsaren rapporterar persisted, och Safari
  gör inte alltid det.

  LÖSNINGEN. När sidan visas efter bakåt/framåt jämför vi antalet på väskan
  med /cart.js. Skiljer det sig ber vi temats egen varukorgslåda att rita om
  sig (dispatch:cart-drawer:refresh), vilket också ritar om ikonen. Vanliga
  sidladdningar gör ingenting extra.

  Laddas från snippets/sunne-oppetdagar.liquid.
*/
(function () {
  'use strict';

  function visatAntal() {
    var bubbla = document.getElementById('cart-icon-bubble');
    if (!bubbla) { return null; }
    var siffra = bubbla.querySelector('[aria-hidden="true"]');
    return siffra ? (parseInt(siffra.textContent, 10) || 0) : 0;
  }

  function synka() {
    var visat = visatAntal();
    if (visat === null) { return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === visat) { return; }
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          return;
        }
        if (document.querySelector('cart-items')) {
          window.location.reload();
          return;
        }
        fetch(window.location.pathname + '?sections=cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (s) {
            var bubbla = document.getElementById('cart-icon-bubble');
            var tmpl = document.createElement('template');
            tmpl.innerHTML = s['cart-icon-bubble'] || '';
            var inre = tmpl.content.querySelector('.shopify-section');
            if (bubbla && inre) { bubbla.innerHTML = inre.innerHTML; }
          });
      })
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (e) {
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (e.persisted || (nav && nav.type === 'back_forward')) { synka(); }
  });
})();
